import apiClient from '../lib/apiClient';

export type EnableApiIntegrationResponse = {
  success: boolean;
  data: {
    apiKey: string;
  webhookUrl?: string;
  webhookSecret?: string;
  };
};

export async function enableApiIntegration(): Promise<EnableApiIntegrationResponse> {
  const res = await apiClient.post<EnableApiIntegrationResponse>('/api-integration/enable', {});
  return res as unknown as EnableApiIntegrationResponse;
}

export type DeleteApiIntegrationResponse = {
  success: boolean;
  data: { enabled: false };
};

export async function deleteApiIntegration(): Promise<DeleteApiIntegrationResponse> {
  const res = await apiClient.post<DeleteApiIntegrationResponse>('/api-integration/delete', {});
  return res as unknown as DeleteApiIntegrationResponse;
}

export type SetWebhookUrlResponse = {
  success: boolean;
  data: { webhookUrl: string | null };
};

export async function setApiWebhookUrl(webhookUrl: string | null): Promise<SetWebhookUrlResponse> {
  const res = await apiClient.post<SetWebhookUrlResponse>('/api-integration/webhook', { webhookUrl });
  return res as unknown as SetWebhookUrlResponse;
}

export type GetApiStatusResponse = {
  success: boolean;
  data: { enabled: boolean; apiKey?: string; webhookUrl?: string; webhookSecret?: string };
};

export async function getApiIntegrationStatus(): Promise<GetApiStatusResponse> {
  const res = await apiClient.get<GetApiStatusResponse>('/api-integration/status');
  return res as unknown as GetApiStatusResponse;
}

export type RotateKeyResponse = {
  success: boolean;
  data: { apiKey: string };
};

export async function rotateApiKey(): Promise<RotateKeyResponse> {
  const res = await apiClient.post<RotateKeyResponse>('/api-integration/rotate-key', {});
  return res as unknown as RotateKeyResponse;
}

export type RotateWebhookSecretResponse = {
  success: boolean;
  data: { webhookSecret: string };
};

export async function rotateWebhookSecret(): Promise<RotateWebhookSecretResponse> {
  const res = await apiClient.post<RotateWebhookSecretResponse>('/api-integration/rotate-webhook-secret', {});
  return res as unknown as RotateWebhookSecretResponse;
}

export type WebhookLogItem = {
  id: number;
  channelId?: number | null;
  webhookUrl: string;
  eventId: string;
  eventType: string;
  attempt: number;
  success: boolean;
  status?: number | null;
  error?: string | null;
  createdAt: string; // ISO string
  nextAttemptAt?: string | null;
  responseText?: string | null;
};

export type ListWebhookLogsResponse = {
  success: boolean;
  data: { items: WebhookLogItem[]; total: number; page: number; pageSize: number };
};

export async function listWebhookLogs(params?: { page?: number; pageSize?: number; eventType?: string; from?: string; to?: string }): Promise<ListWebhookLogsResponse> {
  const query = new URLSearchParams();
  if (params?.page) query.set('page', String(params.page));
  if (params?.pageSize) query.set('pageSize', String(params.pageSize));
  if (params?.eventType) query.set('eventType', params.eventType);
  if (params?.from) query.set('from', params.from);
  if (params?.to) query.set('to', params.to);
  const res = await apiClient.get<ListWebhookLogsResponse>(`/api-integration/webhook-logs?${query.toString()}`);
  return res as unknown as ListWebhookLogsResponse;
}

export type SetEnabledResponse = {
  success: boolean;
  data: { enabled: boolean };
};

export async function setApiEnabled(enabled: boolean): Promise<SetEnabledResponse> {
  const res = await apiClient.post<SetEnabledResponse>('/api-integration/enabled', { enabled });
  return res as unknown as SetEnabledResponse;
}
